export default "__VITE_ASSET__BU6YGgy5__"